<template>
  <div>
    <el-row class="form-item template-form-item">
      <el-col :span="3">订单备注</el-col>
      <el-col :span="21">
        <el-input type="textarea" rows="3" resize="none" @change="setRemark" v-model="remark" :maxlength="200" show-word-limit placeholder="最多可输入200个字符"></el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    mark: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      remark: ''
    }
  },
  methods: {
    setRemark () {
      this.$emit('setRemark', this.remark)
    },
    getRemark () {
      this.remark = this.mark
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
}
</style>
